<template>
  <div class="game-list">
    <!--海报-->
    <div class="banner container-fluid">
      <img src="../../assets/images/chanpin.png" alt="">
    </div>
    <div class="about1">
      <div class="title">
        <div>
          解决方案
        </div>
        <div class="yinwen">
          Solve
        </div>
        <img src="../../assets/images/index/shenglue.png" alt="">
      </div>
    </div>
    <p>
      深耕黄金珠宝行业产业链数字化转型，涵盖产销研信息化、数字化和智能化的模块化及全套解决方案
    </p>
    <div class="chanpingjieshou">
      <!-- <img style="width:200px;" src="../../assets/images/index/right.png" alt="">
      <img style="width:200px" src="../../assets/images/index/left.png" alt="">
      <img style="width:200px" src="../../assets/images/index/right.png" alt="">
      <img style="width:200px" src="../../assets/images/index/left.png" alt=""> -->
      <div class="div">
        <div class="right">
          <img src="../../assets/images/xwzx/store.png" alt="">
          <div>
            黄金珠宝零售门店综合 <br/> 解决方案
          </div>
        </div>
        <div class="left">
          <img src="../../assets/images/xwzx/comprehensive.png" alt="">
          <div>
            黄金珠宝行业智慧零售综合 <br/> 解决方案
          </div>
        </div>
        <div class="right">
          <img src="../../assets/images/xwzx/Administration.png" alt="">
          <div>
            黄金珠宝行业供应链端智能化 <br/> 解决方案
          </div>
        </div>
        <div class="left">
          <img src="../../assets/images/xwzx/finance.png" alt="">
          <div>
            黄金珠宝产业平台+金融 <br/> 解决方案
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      isMobile:false,
    }
  },
  mounted() {
  },
  created() {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      this.isMobile = true // 手机端
    } else {
      this.isMobile = false // alert('PC端')
    }
  },
  watch: {

  },
  methods: {


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@screen-xs-min: 768px;
@screen-md-min: 992px;
@screen-lg-min: 1200px;

.game-list {
  // max-width:1920px;
  margin: 0 auto;
  @media screen and(min-width: 770px) {
    margin-top: 80px;
  }
  @media screen and(max-width: 770px) {
    margin-top: 50px;
  }
  // 海报
  .banner {
    margin: 0 auto;
    // max-width:1920px;
    padding: 0;
    text-align: center;
    position: relative;
  }
.about1 {
    .title{
      font-size: 35px;
      font-weight: 300;
      color: #000000;
      @media screen and(max-width:1720px){
        font-size: 32px;
      }
      @media screen and(max-width:1640px){
        font-size: 30px;
      }
      @media screen and(max-width:1520px){
        font-size: 28px;
      }
      @media screen and(max-width:1380px){
        font-size: 26px;
      }
      @media screen and(max-width:1200px){
        font-size: 24px;
      }
      @media screen and(max-width:1180px){
        font-size: 22px;
      }
      @media screen and(max-width:1024px){
        font-size: 20px;
      }
      @media screen and(max-width:1005px){
        width: 100%;
        font-size: 20px;
      }
      @media screen and(max-width:768px){
        width: 100%;
        font-size: 20px;
      }
      @media screen and(max-width:540px){
        font-size: 20px;
      }
      .yinwen{
        color: #999999;
        font-size: 24px;
        @media screen and(max-width:1200px){
          font-size: 18px;
        }
        @media screen and(max-width:768px){
          font-size: 15px;
        }
      }
      img{
        width: 110px;
        @media screen and(max-width:1200px){
          width: 90px;
        }
        @media screen and(max-width:768px){
          width: 60px;
        }
      }
    }
  }
  p{
    font-size: 24px;
    width: 80%;
    text-align: center;
    margin: 0 auto;
    margin-top: 30px;
    @media screen and(max-width:1200px){
      font-size: 20px;
      width: 90%;
      margin-top: 25px;
    }
    @media screen and(max-width:768px){
      font-size: 16px;
      width: 90%;
      margin-top: 25px;
    }
  }
  .chanpingjieshou{
    width: 80%;
    margin: 150px auto 90px;
    overflow: hidden;
    @media screen and(max-width:1200px){
      margin: 100px auto 70px;
      width: 90%;
    }
    @media screen and(max-width:768px){
      width: 90%;
      margin: 80px auto 50px;
      overflow: hidden;overflow-x:auto;white-space: nowrap;
      
    }
    .div{
      @media screen and(max-width:768px){
        width: 1000px;
        margin-left: 20px;
      }
      display: flex;
    }
    .left{
      width: 380px;
      height: 650px;
      background-image: url('../../assets/images/index/left.png');
      background-size: 100% 100%;
      position: relative;
      @media screen and(max-width:1200px){
        width: 250px;
        height: 450px;
      }
      @media screen and(max-width:768px){
        width: 250px;
        height: 450px;
      }
      img{
        margin-top: 80px;
        width: 80%;
        height: auto;
        @media screen and(max-width:1200px){
          margin-top: 50px;
          width: 80%;
          height: auto;
        }
        @media screen and(max-width:768px){
          margin-top: 60px;
          width: 80%;
        }
      }
      div{
        width: 100%;
        font-size: 18px;
        color: #fff;
        position: absolute;
        text-align: center;
        bottom: 100px;
        @media screen and(max-width:1200px){
          font-size: 16px;
          bottom: 80px;
        }
        @media screen and(max-width:768px){
          font-size: 14px;
          bottom: 80px;
        }
      }
    }
    .right{
      width: 380px;
      height: 650px;
      background-image: url('../../assets/images/index/right.png');
      background-size: 100% 100%;
      position: relative;
      @media screen and(max-width:1200px){
        width: 250px;
        height: 450px;
      }
      @media screen and(max-width:768px){
        width: 250px;
        height: 450px;
      }
      img{
        margin-top: 80px;
        width: 80%;
        height: auto;
        @media screen and(max-width:1200px){
          margin-top: 50px;
          width: 80%;
          height: auto;
        }
        @media screen and(max-width:768px){
          margin-top: 40px;
          width: 80%;
        }
      }
      div{
        width: 100%;
        font-size: 18px;
        color: #fff;
        position: absolute;
        text-align: center;
        bottom: 100px;
        @media screen and(max-width:1200px){
          font-size: 16px;
          bottom: 80px;
        }
        @media screen and(max-width:768px){
          font-size: 14px;
          bottom: 80px;
        }
      }
    }
  }
}

</style>
